export enum CustomerStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum CustomerDetailStatus {
  DRAFT = "draft",
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum CustomerPriceQuoteStatus {
  DRAFT = "DRAFT",
  SENT = "SENT",
  ACCEPTED = "ACCEPTED",
}

export interface CustomerPriceQuote {
  id: string;
  quoteNumber: string;
  createdAt: string;
  projectTypeKey: string;
  revisionNumber: number;
  totalValue: number;
  status: CustomerPriceQuoteStatus;
  validUntil: string;
}

export enum CustomerDetailTab {
  PRICE_QUOTE = "PRICE_QUOTE",
  WORK_INSTRUCTIONS = "WORK_INSTRUCTIONS",
  FINANCIAL = "FINANCIAL",
  FILES = "FILES",
  TIMELINE = "TIMELINE",
}

export const CUSTOMER_DETAIL_TAB_LABELS: Record<CustomerDetailTab, string> = {
  [CustomerDetailTab.PRICE_QUOTE]: "CUSTOMERS.DETAILS.TABS.PRICE_QUOTE",
  [CustomerDetailTab.WORK_INSTRUCTIONS]:
    "CUSTOMERS.DETAILS.TABS.WORK_INSTRUCTIONS",
  [CustomerDetailTab.FINANCIAL]: "CUSTOMERS.DETAILS.TABS.FINANCIAL",
  [CustomerDetailTab.FILES]: "CUSTOMERS.DETAILS.TABS.FILES",
  [CustomerDetailTab.TIMELINE]: "CUSTOMERS.DETAILS.TABS.TIMELINE",
};

export const CUSTOMER_DETAIL_TABS = Object.values(CustomerDetailTab);

export type CustomerStatusFilter = CustomerStatus | "ALL";

export interface Customer {
  customerId: number;
  customerName: string;
  customerShortName: string;
  category: string;
  contactPersonName: string;
  contactPhone: string;
  fax: string;
  address: string;
  moreDetails: string;
  activeWorkOrdersCount: number;
  totalRevenue: number;
  status: string;
}

export interface CustomerListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: Customer[];
}

export interface CustomerForm {
  customerName: string;
  category: string;
  contactPerson: string;
  contactPhone: string;
  contactEmail: string;
}

export type CustomerSelectOption = {
  value: string;
  labelKey?: string;
  label?: string;
};

export type CustomerFieldConfig = {
  key: keyof CustomerForm;
  label: string;
  type: "select" | "text";
  options?: CustomerSelectOption[];
  placeholder?: string;
};

export interface CustomerContactPerson {
  contactId: number;
  contactPersonName: string;
  role: string;
  contactPhone: string;
  contactEmail: string;
}

export interface CustomerDetails {
  customerId: number;
  customerName: string;
  customerShortName: string;
  category: string;
  contactPersonName: string;
  contactPhone: string;
  fax: string;
  address: string;
  moreDetails: string;
  activeWorkOrdersCount: number;
  totalRevenue: number;
  status: string;
  contacts: CustomerContactPerson[];
  priceQuotes: CustomerPriceQuote[];
}

export interface CustomerDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: CustomerDetails;
}

export interface CustomersState {
  loading: boolean;
  saving: boolean;
  list: Customer[];
  statusFilter: CustomerStatusFilter;
  selectedCustomerId: string | null;
  customerDetails: CustomerDetails | null;
  detailLoading: boolean;
  error: string | null;
  isAddModalOpen: boolean;
  form: CustomerForm;
}
